import React, { useEffect } from "react"
import { DismissButton, StyledToast, ToastContent, ToastText } from "./styles"

const Toast = ({ message, id, duration, removeToast }) => {
  const handleDismiss = () => {
    removeToast(id)
  }

  useEffect(() => {
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }, [duration, removeToast, id])

  return (
    <StyledToast>
      <ToastContent>
        <ToastText>{message}</ToastText>
        <DismissButton onClick={handleDismiss}>x</DismissButton>
      </ToastContent>
    </StyledToast>
  )
}

export default Toast
